<router-outlet></router-outlet>


@if(loaderLoading){
<div class="preloader-container position-fixed left-0 right-0 top-0 bottom-0 h-100 w-100 d-flex justify-content-center align-items-center">
    <img src="assets/images/plant.gif"  alt="loader" />
</div>
}

